function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components";
import { LinkFontAwesome } from "./LinkFontAwesome";
const StyledLinkFontAwesome = styled(LinkFontAwesome)`
  font-size: .9rem;
`;

class LinkDelete extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement("a", {
        className: "action-icon"
      }, ' ', /*#__PURE__*/React.createElement(StyledLinkFontAwesome, {
        icon: faTrashAlt,
        cypress: this.props.cypress
      }));
    });
  }

}

export default LinkDelete;